import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';
import { mix } from 'polished';

export const Button = styled.button`
    width: 197px;
    height: 42px;
    border-radius: 12px;
    background-color: #2e3c50;
    border: solid 1px #2e3c50;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        border: solid 2px #77808d;
    }

    &:focus {
        border: solid 2px #77808d;
        outline: none;
    }

    &:active{
        background-color: #2e3c50;
        border: solid 1px #2e3c50;
    }

    &:disabled {
        border: 0;
        background: ${mix(0.4, '#2e3c50', '#fff')};
        cursor: not-allowed;
    }

`;

export const Icon = styled(PlusOutlined)`
    margin-right: 14px;
    color: #ffffff;
`;